import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import img from "../images/saudi-arabia.jpg";
import { MapContainer, TileLayer, Polygon, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { useLands } from "../context/LandsContext";
import { shape } from "../data/lands";
import Spinner from "../components/Shared/Spinner";

const LandDetails = () => {
  const { id } = useParams();
  const { getLandById, isLoading } = useLands();
  const [landDetails, setLandDetails] = useState(null);

  useEffect(() => {
    if (!isLoading) {
      const land = getLandById(id);
      setLandDetails(land);
    }
  }, [id, getLandById, isLoading]);

  const cleanShape = (shape) =>
    shape
      ?.filter((polygon) => Array.isArray(polygon))
      ?.map((polygon) =>
        polygon
          ?.flat()
          ?.filter((coord) => Array.isArray(coord) && coord.length === 2)
          ?.map(([lng, lat]) => [lat, lng])
      );

  const cleanedShape = cleanShape(shape);
  const center = cleanedShape?.[0][0];

  if (isLoading || !landDetails) {
    return <Spinner />;
  }

  return (
    <div className="container mt-5" dir="rtl">
      <h2 className="mb-4 fw-bold">{landDetails?.name}</h2>
      <div className="row">
        <div className="col-md-6 mb-4">
          <img
            src={img}
            alt={landDetails?.name}
            className="img-fluid rounded shadow mb-3"
          />
          <p className="card-text mb-3">
            <strong>نوع الارض : </strong> {landDetails?.property_type}
          </p>
          <p className="card-text mb-3">
            <strong>رقم الارض: </strong> {landDetails?.property_number}
          </p>
          <p className="card-text mb-3">
            <strong>حالة الارض : </strong> {landDetails?.property_status}
          </p>
          <p className="card-text mb-3"></p>
          <p className="card-text text-success fw-bold mb-3">
            <strong> السعر : </strong>
            {landDetails?.price_amount.toLocaleString()} ريال
          </p>
          <Link to={`/`} className="btn btn-primary ms-auto d-block">
            الرجوع الي القائمة
          </Link>
          <div className="border p-3 rounded bg-light mt-4">
            <h5 className="mb-3">طلب حجز الأرض</h5>
            <form>
              <div className="mb-2">
                <label>الاسم</label>
                <input type="text" className="form-control" />
              </div>
              <div className="mb-2">
                <label>رقم الهاتف</label>
                <input type="tel" className="form-control" />
              </div>
              <div className="mb-2">
                <label>رسالة</label>
                <textarea className="form-control" rows="2"></textarea>
              </div>
              <button type="submit" className="btn btn-success w-100">
                إرسال الطلب
              </button>
            </form>
            <hr />
            <p className="text-muted small mb-0">
              📞 للتواصل: <strong>+966 55 555 5555</strong>
            </p>
          </div>
        </div>
        <div className="col-md-6">
          <h5 className="mb-3">موقع الأرض على الخريطة</h5>
          <div className="border rounded shadow" style={{ height: "400px" }}>
            <MapContainer
              center={center}
              zoom={15}
              style={{ height: "100%", width: "100%" }}
            >
              <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution="&copy; OpenStreetMap contributors"
              />
              {cleanedShape.map((polygon, idx) => (
                <Polygon
                  key={idx}
                  positions={polygon}
                  pathOptions={{ color: "#3399ff" }}
                >
                  <Popup>
                    <div className="text-center" dir="rtl">
                      <div className="mb-2">
                        <strong> مساحة الأرض : </strong>
                        <span>{landDetails?.plot_area_m2} متر مربع</span>
                      </div>
                      <div className="mb-2">
                        <strong> أبعاد الارض : </strong>
                        <span>
                          {landDetails?.plot_length} متر (طول) ×
                          {landDetails?.plot_width} متر (عرض)
                        </span>
                      </div>
                      <div className=" mb-2">
                        <strong> الخدمات المتوفرة : </strong>
                        {landDetails?.nearby_connectivity_ids?.map(
                          (item, index) => (
                            <span key={item.id}>
                              {item.name}
                              {index <
                                landDetails?.nearby_connectivity_ids?.length -
                                  1 && " - "}
                            </span>
                          )
                        )}
                      </div>
                      <div className="mb-2">
                        <strong> الشوارع المحيطة : </strong>
                        <span>{landDetails?.street_name}</span>
                      </div>
                      <div className="card-text mb-3">
                        <strong> مميزات اخري : </strong>
                        {landDetails?.tag_ids.map((item, index) => (
                          <span key={item.id}>
                            {item.name}
                            {index < landDetails.tag_ids.length - 1 && " - "}
                          </span>
                        ))}
                      </div>
                    </div>
                  </Popup>
                </Polygon>
              ))}
            </MapContainer>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandDetails;
